import { memo, useRef } from "react";
import classNames from "classnames";
import deepEqual from "fast-deep-equal";
import { useIframeContent } from "./hooks/useIframeContent";
import { getDimensionStyle } from "./utils";

export interface MemoizedIframeProps {
  content: {
    head: string;
    body: string;
  };
  height: string | number;
  id: string;
  isPreviewMode: boolean;
  width: string | number;
}

const MemoizedIframeComponent = ({
  content,
  height,
  id,
  isPreviewMode,
  width,
}: MemoizedIframeProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useIframeContent(iframeRef, {
    content,
    height,
  });

  const dimensionStyle = getDimensionStyle({
    height,
    width,
  });

  return (
    <iframe
      ref={iframeRef}
      loading="lazy"
      title={`custom-html-embed-${id}`}
      className={classNames("wb-w-full", {
        "wb-pointer-events-none": isPreviewMode,
      })}
      style={dimensionStyle}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
    />
  );
};

MemoizedIframeComponent.displayName = "MemoizedIframe";

export const MemoizedIframe = memo(MemoizedIframeComponent, deepEqual);
